<template>
    <b-card no-body class="mb-4 product_information">
        <template v-slot:header>
            <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">
                    {{ $t("product_info") }}
                </h5>
                <b-button
                    size="sm"
                    variant="primary"
                    class="btn-round"
                    @click="showProductDialog = true"
                    v-if="$can('edit base product')"
                >
                    <font-awesome-icon :icon="['fas', 'pen']" />
                    {{ $t("edit") }}
                </b-button>
                <base-product-dialog
                    @saved="reloadProduct"
                    :collection_id="product.collection.id"
                    :id="product.id"
                    v-model="showProductDialog"
                >
                </base-product-dialog>
            </div>
        </template>
        <b-card-body>
            <div class="mb-3">
                <div class="font-weight-bold">{{ $t("client") }}</div>
                <div class="">{{ product.collection.client.name }}</div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">{{ $t("collection") }}</div>
                <div class="">{{ product.collection.name }}</div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">{{ $t("name") }}</div>
                <div class="">{{ product.name }}</div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">{{ $t("variants") }}</div>
                <b-form-select v-model="variantId">
                    <b-form-select-option :value="null">{{
                        $t("base_product")
                    }}</b-form-select-option>
                    <b-form-select-option
                        v-for="v in product.variants"
                        :key="v.id"
                        :value="v.id"
                    >
                        {{ v.name !== "" ? `${v.reference} - ${v.name}` : v.reference }}
                    </b-form-select-option>
                </b-form-select>
            </div>
            <dl class="row mb-0" v-if="variant">
                <template v-for="option in variant.options">
                    <dt class="col-sm-4" :key="`label_${option.option_id}`">
                        {{ option.name | capitalize }}
                    </dt>
                    <dd class="col-sm-8" :key="`value_${option.option_id}`">
                        {{ option.value }}
                    </dd>
                </template>
            </dl>
            <div v-if="product.manufacturers.length">
                <hr />
                <strong>{{ $t("manufacturers") | capitalize }}</strong>
                <b-list-group class="manufacturers-list">
                    <b-list-group-item
                        class="px-0"
                        v-for="manufacturer in product.manufacturers"
                        :key="manufacturer.id"
                    >
                        <div>{{ manufacturer.name }}</div>
                        <small
                            >{{ manufacturer.address }} {{ manufacturer.city }}
                            {{ manufacturer.country }}</small
                        >
                    </b-list-group-item>
                </b-list-group>
            </div>
        </b-card-body>
        <b-card-footer>
            <small class="text-muted">{{
                $t("last_modified_ago", { timeago: product.updated_at })
            }}</small>
        </b-card-footer>
    </b-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import BaseProductDialog from "../EditDialogs/BaseProductDialog";
import { createHelpers } from "vuex-map-fields";

const { mapFields } = createHelpers({
  getterType: "smartVaultProduct/getField",
  mutationType: "smartVaultProduct/updateVariantField"
});

export default {
  name: "Information",
  components: { BaseProductDialog },
  data() {
    return {
      showProductDialog: false
    };
  },
  methods: {
    ...mapActions("smartVaultProduct", ["getProduct"]),
    reloadProduct() {
      this.getProduct(this.product.id);
    }
  },
  computed: {
    ...mapState("smartVaultProduct", {
      product: state => state.product,
      loading: state => state.loading
    }),
    ...mapGetters("smartVaultProduct", {
      variant: "getVariant"
    }),
    ...mapFields(["variantId"])
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
};
</script>

<style scoped>
</style>
